export const selectimage = [
    {
        keys: [
            '_boxtype_'
        ],
        data: [
            {
                "key": "16",
                "label": "AutoAR | Propietario",
                "fk_collection": [
                    15
                ],
                "id_suplychain": "5",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "17",
                "label": "AutoAR | Proveedor de Servicios",
                "fk_collection": [
                    16
                ],
                "id_suplychain": "5",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "15",
                "label": "AutoAR | Concesionaria",
                "fk_collection": null,
                "id_suplychain": "5",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "18",
                "label": "token-potrero | Establecimiento Productivo",
                "fk_collection": null,
                "id_suplychain": "9",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "19",
                "label": "ArboAR | Establecimiento Productivo",
                "fk_collection": null,
                "id_suplychain": "10",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "20",
                "label": "ArboAR | Lote Productivo",
                "fk_collection": [
                    19,
                    20
                ],
                "id_suplychain": "10",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "21",
                "label": "VacaAR | Establecimiento Productivo",
                "fk_collection": null,
                "id_suplychain": "11",
                "l1": [
                    "BL",
                    "DZ",
                    "SI",
                    "NZ",
                    "ZM",
                    "WF",
                    "TG",
                    "YE",
                    "MD",
                    "SN",
                    "CH",
                    "VA",
                    "FM",
                    "CO",
                    "IR",
                    "BJ",
                    "MC",
                    "CM",
                    "ES",
                    "NO",
                    "JO",
                    "NL",
                    "PK",
                    "KY",
                    "UY",
                    "CC",
                    "EE",
                    "PL",
                    "PE",
                    "FI",
                    "MA",
                    "ZA",
                    "LC",
                    "LA",
                    "AD",
                    "SK",
                    "GD",
                    "VC",
                    "NC",
                    "MG",
                    "HU",
                    "TC",
                    "TO",
                    "QA",
                    "LU",
                    "JP",
                    "ME",
                    "GL",
                    "CA",
                    "CK",
                    "CN",
                    "TK",
                    "GG",
                    "TN",
                    "SR",
                    "MV",
                    "GP",
                    "AM",
                    "GA",
                    "KP",
                    "KE",
                    "AZ",
                    "SD",
                    "MF",
                    "AE",
                    "NF",
                    "FO",
                    "TR",
                    "AR",
                    "RW",
                    "LV",
                    "BF",
                    "SA",
                    "IT",
                    "CW",
                    "TD",
                    "BD",
                    "VN",
                    "ZW",
                    "MP",
                    "AU",
                    "HR",
                    "IM",
                    "TF",
                    "SX",
                    "PM",
                    "CF",
                    "MN",
                    "GU",
                    "GW",
                    "MT",
                    "SG",
                    "SV",
                    "MQ",
                    "HN",
                    "SE",
                    "MY",
                    "CZ",
                    "GH",
                    "SL",
                    "JE",
                    "CY",
                    "GT",
                    "EG",
                    "LS",
                    "LR",
                    "SM",
                    "TV",
                    "UA",
                    "PH",
                    "MW",
                    "BS",
                    "KW",
                    "EC",
                    "BV",
                    "PW",
                    "CR",
                    "IL",
                    "BR",
                    "LK",
                    "DK",
                    "FK",
                    "CD",
                    "FR",
                    "CG",
                    "CX",
                    "SH",
                    "SC",
                    "NA",
                    "PY",
                    "FJ",
                    "WS",
                    "MH",
                    "UG",
                    "RE",
                    "GR",
                    "AO",
                    "BT",
                    "KR",
                    "ER",
                    "IO",
                    "BG",
                    "KM",
                    "BM",
                    "GS",
                    "AG",
                    "TJ",
                    "MS",
                    "GF",
                    "LI",
                    "SY",
                    "MK",
                    "RU",
                    "SB",
                    "MO",
                    "PR",
                    "BI",
                    "BY",
                    "BH",
                    "VG",
                    "CI",
                    "BZ",
                    "BA",
                    "VE",
                    "BB",
                    "GQ",
                    "TW",
                    "SZ",
                    "PG",
                    "KN",
                    "PF",
                    "HT",
                    "AS",
                    "ET",
                    "SS",
                    "LY",
                    "VU",
                    "US",
                    "PS",
                    "CU",
                    "IE",
                    "PN",
                    "MZ",
                    "NR",
                    "NI",
                    "NE",
                    "AW",
                    "BW",
                    "DO",
                    "CL",
                    "PT",
                    "TM",
                    "OM",
                    "TL",
                    "DM",
                    "GE",
                    "SJ",
                    "AL",
                    "JM",
                    "GN",
                    "KG",
                    "NG",
                    "HK",
                    "AT",
                    "MR",
                    "AX",
                    "IS",
                    "UM",
                    "BN",
                    "ST",
                    "MU",
                    "EH",
                    "HM",
                    "RO",
                    "KH",
                    "TT",
                    "DJ",
                    "VI",
                    "NU",
                    "YT",
                    "TH",
                    "KI",
                    "GB",
                    "GM",
                    "AQ",
                    "DE",
                    "SO",
                    "MX",
                    "NP",
                    "AI",
                    "KZ",
                    "BQ",
                    "LT",
                    "UZ",
                    "LB",
                    "GY",
                    "RS",
                    "ML",
                    "IQ",
                    "MM",
                    "ID",
                    "TZ",
                    "GI",
                    "BO",
                    "IN",
                    "CV",
                    "AF"
                ]
            },
            {
                "key": "22",
                "label": "VacaAR | Frigorífico",
                "fk_collection": null,
                "id_suplychain": "11",
                "l1": [
                    "BL",
                    "DZ",
                    "SI",
                    "NZ",
                    "ZM",
                    "WF",
                    "TG",
                    "YE",
                    "MD",
                    "SN",
                    "CH",
                    "VA",
                    "FM",
                    "CO",
                    "IR",
                    "BJ",
                    "MC",
                    "CM",
                    "ES",
                    "NO",
                    "JO",
                    "NL",
                    "PK",
                    "KY",
                    "UY",
                    "CC",
                    "EE",
                    "PL",
                    "PE",
                    "FI",
                    "MA",
                    "ZA",
                    "LC",
                    "LA",
                    "AD",
                    "SK",
                    "GD",
                    "VC",
                    "NC",
                    "MG",
                    "HU",
                    "TC",
                    "TO",
                    "QA",
                    "LU",
                    "JP",
                    "ME",
                    "GL",
                    "CA",
                    "CK",
                    "CN",
                    "TK",
                    "GG",
                    "TN",
                    "SR",
                    "MV",
                    "GP",
                    "AM",
                    "GA",
                    "KP",
                    "KE",
                    "AZ",
                    "SD",
                    "MF",
                    "AE",
                    "NF",
                    "FO",
                    "TR",
                    "AR",
                    "RW",
                    "LV",
                    "BF",
                    "SA",
                    "IT",
                    "CW",
                    "TD",
                    "BD",
                    "VN",
                    "ZW",
                    "MP",
                    "AU",
                    "HR",
                    "IM",
                    "TF",
                    "SX",
                    "PM",
                    "CF",
                    "MN",
                    "GU",
                    "GW",
                    "MT",
                    "SG",
                    "SV",
                    "MQ",
                    "HN",
                    "SE",
                    "MY",
                    "CZ",
                    "GH",
                    "SL",
                    "JE",
                    "CY",
                    "GT",
                    "EG",
                    "LS",
                    "LR",
                    "SM",
                    "TV",
                    "UA",
                    "PH",
                    "MW",
                    "BS",
                    "KW",
                    "EC",
                    "BV",
                    "PW",
                    "CR",
                    "IL",
                    "BR",
                    "LK",
                    "DK",
                    "FK",
                    "CD",
                    "FR",
                    "CG",
                    "CX",
                    "SH",
                    "SC",
                    "NA",
                    "PY",
                    "FJ",
                    "WS",
                    "MH",
                    "UG",
                    "RE",
                    "GR",
                    "AO",
                    "BT",
                    "KR",
                    "ER",
                    "IO",
                    "BG",
                    "KM",
                    "BM",
                    "GS",
                    "AG",
                    "TJ",
                    "MS",
                    "GF",
                    "LI",
                    "SY",
                    "MK",
                    "RU",
                    "SB",
                    "MO",
                    "PR",
                    "BI",
                    "BY",
                    "BH",
                    "VG",
                    "CI",
                    "BZ",
                    "BA",
                    "VE",
                    "BB",
                    "GQ",
                    "TW",
                    "SZ",
                    "PG",
                    "KN",
                    "PF",
                    "HT",
                    "AS",
                    "ET",
                    "SS",
                    "LY",
                    "VU",
                    "US",
                    "PS",
                    "CU",
                    "IE",
                    "PN",
                    "MZ",
                    "NR",
                    "NI",
                    "NE",
                    "AW",
                    "BW",
                    "DO",
                    "CL",
                    "PT",
                    "TM",
                    "OM",
                    "TL",
                    "DM",
                    "GE",
                    "SJ",
                    "AL",
                    "JM",
                    "GN",
                    "KG",
                    "NG",
                    "HK",
                    "AT",
                    "MR",
                    "AX",
                    "IS",
                    "UM",
                    "BN",
                    "ST",
                    "MU",
                    "EH",
                    "HM",
                    "RO",
                    "KH",
                    "TT",
                    "DJ",
                    "VI",
                    "NU",
                    "YT",
                    "TH",
                    "KI",
                    "GB",
                    "GM",
                    "AQ",
                    "DE",
                    "SO",
                    "MX",
                    "NP",
                    "AI",
                    "KZ",
                    "BQ",
                    "LT",
                    "UZ",
                    "LB",
                    "GY",
                    "RS",
                    "ML",
                    "IQ",
                    "MM",
                    "ID",
                    "TZ",
                    "GI",
                    "BO",
                    "IN",
                    "CV",
                    "AF"
                ]
            },
            {
                "key": "23",
                "label": "VacaAR | Comercializador",
                "fk_collection": null,
                "id_suplychain": "11",
                "l1": [
                    "BL",
                    "DZ",
                    "SI",
                    "NZ",
                    "ZM",
                    "WF",
                    "TG",
                    "YE",
                    "MD",
                    "SN",
                    "CH",
                    "VA",
                    "FM",
                    "CO",
                    "IR",
                    "BJ",
                    "MC",
                    "CM",
                    "ES",
                    "NO",
                    "JO",
                    "NL",
                    "PK",
                    "KY",
                    "UY",
                    "CC",
                    "EE",
                    "PL",
                    "PE",
                    "FI",
                    "MA",
                    "ZA",
                    "LC",
                    "LA",
                    "AD",
                    "SK",
                    "GD",
                    "VC",
                    "NC",
                    "MG",
                    "HU",
                    "TC",
                    "TO",
                    "QA",
                    "LU",
                    "JP",
                    "ME",
                    "GL",
                    "CA",
                    "CK",
                    "CN",
                    "TK",
                    "GG",
                    "TN",
                    "SR",
                    "MV",
                    "GP",
                    "AM",
                    "GA",
                    "KP",
                    "KE",
                    "AZ",
                    "SD",
                    "MF",
                    "AE",
                    "NF",
                    "FO",
                    "TR",
                    "AR",
                    "RW",
                    "LV",
                    "BF",
                    "SA",
                    "IT",
                    "CW",
                    "TD",
                    "BD",
                    "VN",
                    "ZW",
                    "MP",
                    "AU",
                    "HR",
                    "IM",
                    "TF",
                    "SX",
                    "PM",
                    "CF",
                    "MN",
                    "GU",
                    "GW",
                    "MT",
                    "SG",
                    "SV",
                    "MQ",
                    "HN",
                    "SE",
                    "MY",
                    "CZ",
                    "GH",
                    "SL",
                    "JE",
                    "CY",
                    "GT",
                    "EG",
                    "LS",
                    "LR",
                    "SM",
                    "TV",
                    "UA",
                    "PH",
                    "MW",
                    "BS",
                    "KW",
                    "EC",
                    "BV",
                    "PW",
                    "CR",
                    "IL",
                    "BR",
                    "LK",
                    "DK",
                    "FK",
                    "CD",
                    "FR",
                    "CG",
                    "CX",
                    "SH",
                    "SC",
                    "NA",
                    "PY",
                    "FJ",
                    "WS",
                    "MH",
                    "UG",
                    "RE",
                    "GR",
                    "AO",
                    "BT",
                    "KR",
                    "ER",
                    "IO",
                    "BG",
                    "KM",
                    "BM",
                    "GS",
                    "AG",
                    "TJ",
                    "MS",
                    "GF",
                    "LI",
                    "SY",
                    "MK",
                    "RU",
                    "SB",
                    "MO",
                    "PR",
                    "BI",
                    "BY",
                    "BH",
                    "VG",
                    "CI",
                    "BZ",
                    "BA",
                    "VE",
                    "BB",
                    "GQ",
                    "TW",
                    "SZ",
                    "PG",
                    "KN",
                    "PF",
                    "HT",
                    "AS",
                    "ET",
                    "SS",
                    "LY",
                    "VU",
                    "US",
                    "PS",
                    "CU",
                    "IE",
                    "PN",
                    "MZ",
                    "NR",
                    "NI",
                    "NE",
                    "AW",
                    "BW",
                    "DO",
                    "CL",
                    "PT",
                    "TM",
                    "OM",
                    "TL",
                    "DM",
                    "GE",
                    "SJ",
                    "AL",
                    "JM",
                    "GN",
                    "KG",
                    "NG",
                    "HK",
                    "AT",
                    "MR",
                    "AX",
                    "IS",
                    "UM",
                    "BN",
                    "ST",
                    "MU",
                    "EH",
                    "HM",
                    "RO",
                    "KH",
                    "TT",
                    "DJ",
                    "VI",
                    "NU",
                    "YT",
                    "TH",
                    "KI",
                    "GB",
                    "GM",
                    "AQ",
                    "DE",
                    "SO",
                    "MX",
                    "NP",
                    "AI",
                    "KZ",
                    "BQ",
                    "LT",
                    "UZ",
                    "LB",
                    "GY",
                    "RS",
                    "ML",
                    "IQ",
                    "MM",
                    "ID",
                    "TZ",
                    "GI",
                    "BO",
                    "IN",
                    "CV",
                    "AF"
                ]
            },
            {
                "key": "24",
                "label": "VacaAR | Importador",
                "fk_collection": null,
                "id_suplychain": "11",
                "l1": [
                    "BL",
                    "DZ",
                    "SI",
                    "NZ",
                    "ZM",
                    "WF",
                    "TG",
                    "YE",
                    "MD",
                    "SN",
                    "CH",
                    "VA",
                    "FM",
                    "CO",
                    "IR",
                    "BJ",
                    "MC",
                    "CM",
                    "ES",
                    "NO",
                    "JO",
                    "NL",
                    "PK",
                    "KY",
                    "UY",
                    "CC",
                    "EE",
                    "PL",
                    "PE",
                    "FI",
                    "MA",
                    "ZA",
                    "LC",
                    "LA",
                    "AD",
                    "SK",
                    "GD",
                    "VC",
                    "NC",
                    "MG",
                    "HU",
                    "TC",
                    "TO",
                    "QA",
                    "LU",
                    "JP",
                    "ME",
                    "GL",
                    "CA",
                    "CK",
                    "CN",
                    "TK",
                    "GG",
                    "TN",
                    "SR",
                    "MV",
                    "GP",
                    "AM",
                    "GA",
                    "KP",
                    "KE",
                    "AZ",
                    "SD",
                    "MF",
                    "AE",
                    "NF",
                    "FO",
                    "TR",
                    "AR",
                    "RW",
                    "LV",
                    "BF",
                    "SA",
                    "IT",
                    "CW",
                    "TD",
                    "BD",
                    "VN",
                    "ZW",
                    "MP",
                    "AU",
                    "HR",
                    "IM",
                    "TF",
                    "SX",
                    "PM",
                    "CF",
                    "MN",
                    "GU",
                    "GW",
                    "MT",
                    "SG",
                    "SV",
                    "MQ",
                    "HN",
                    "SE",
                    "MY",
                    "CZ",
                    "GH",
                    "SL",
                    "JE",
                    "CY",
                    "GT",
                    "EG",
                    "LS",
                    "LR",
                    "SM",
                    "TV",
                    "UA",
                    "PH",
                    "MW",
                    "BS",
                    "KW",
                    "EC",
                    "BV",
                    "PW",
                    "CR",
                    "IL",
                    "BR",
                    "LK",
                    "DK",
                    "FK",
                    "CD",
                    "FR",
                    "CG",
                    "CX",
                    "SH",
                    "SC",
                    "NA",
                    "PY",
                    "FJ",
                    "WS",
                    "MH",
                    "UG",
                    "RE",
                    "GR",
                    "AO",
                    "BT",
                    "KR",
                    "ER",
                    "IO",
                    "BG",
                    "KM",
                    "BM",
                    "GS",
                    "AG",
                    "TJ",
                    "MS",
                    "GF",
                    "LI",
                    "SY",
                    "MK",
                    "RU",
                    "SB",
                    "MO",
                    "PR",
                    "BI",
                    "BY",
                    "BH",
                    "VG",
                    "CI",
                    "BZ",
                    "BA",
                    "VE",
                    "BB",
                    "GQ",
                    "TW",
                    "SZ",
                    "PG",
                    "KN",
                    "PF",
                    "HT",
                    "AS",
                    "ET",
                    "SS",
                    "LY",
                    "VU",
                    "US",
                    "PS",
                    "CU",
                    "IE",
                    "PN",
                    "MZ",
                    "NR",
                    "NI",
                    "NE",
                    "AW",
                    "BW",
                    "DO",
                    "CL",
                    "PT",
                    "TM",
                    "OM",
                    "TL",
                    "DM",
                    "GE",
                    "SJ",
                    "AL",
                    "JM",
                    "GN",
                    "KG",
                    "NG",
                    "HK",
                    "AT",
                    "MR",
                    "AX",
                    "IS",
                    "UM",
                    "BN",
                    "ST",
                    "MU",
                    "EH",
                    "HM",
                    "RO",
                    "KH",
                    "TT",
                    "DJ",
                    "VI",
                    "NU",
                    "YT",
                    "TH",
                    "KI",
                    "GB",
                    "GM",
                    "AQ",
                    "DE",
                    "SO",
                    "MX",
                    "NP",
                    "AI",
                    "KZ",
                    "BQ",
                    "LT",
                    "UZ",
                    "LB",
                    "GY",
                    "RS",
                    "ML",
                    "IQ",
                    "MM",
                    "ID",
                    "TZ",
                    "GI",
                    "BO",
                    "IN",
                    "CV",
                    "AF"
                ]
            },
            {
                "key": "25",
                "label": "VacaPN | Establecimiento Productivo",
                "fk_collection": null,
                "id_suplychain": "11",
                "l1": [
                    "PA"
                ]
            },
            {
                "key": "26",
                "label": "VacaPN | Comercializador",
                "fk_collection": null,
                "id_suplychain": "11",
                "l1": [
                    "PA"
                ]
            },
            {
                "key": "27",
                "label": "SLB | Tomador",
                "fk_collection": null,
                "id_suplychain": "12",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "28",
                "label": "SLB | Depositante",
                "fk_collection": null,
                "id_suplychain": "12",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "29",
                "label": "SLB | ALyC",
                "fk_collection": null,
                "id_suplychain": "12",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "30",
                "label": "SLB | Depositante",
                "fk_collection": [
                    28
                ],
                "id_suplychain": "12",
                "l1": [
                    "AR"
                ]
            },
            {
                "key": "31",
                "label": "GrainBE | Cooperative",
                "fk_collection": null,
                "id_suplychain": "13",
                "l1": [
                    "BE"
                ]
            },
            {
                "key": "32",
                "label": "GrainBE | Belgomalt Grain Warehouse",
                "fk_collection": null,
                "id_suplychain": "13",
                "l1": [
                    "BE"
                ]
            },
            {
                "key": "33",
                "label": "MaltBE | Belgomalt Malting & Warehouse",
                "fk_collection": null,
                "id_suplychain": "13",
                "l1": [
                    "BE"
                ]
            },
            {
                "key": "34",
                "label": "MaltBE | Breweries",
                "fk_collection": null,
                "id_suplychain": "13",
                "l1": [
                    "BE"
                ]
            },
            {
                "key": "35",
                "label": "LeatherT | Tannery 1",
                "fk_collection": null,
                "id_suplychain": "14",
                "l1": [
                    "DK",
                    "ES"
                ]
            },
            {
                "key": "36",
                "label": "LeatherT | Tannery 2",
                "fk_collection": null,
                "id_suplychain": "14",
                "l1": [
                    "DK",
                    "ES"
                ]
            },
            {
                "key": "37",
                "label": "LeatherT | Leather Bags Producer",
                "fk_collection": null,
                "id_suplychain": "14",
                "l1": [
                    "DK",
                    "ES"
                ]
            },
            {
                "key": "38",
                "label": "SLB | Emisor",
                "fk_collection": null,
                "id_suplychain": "12",
                "l1": [
                    "AR"
                ]
            },
        ]
    }
]